import React, { useState } from "react";
import { supabase } from "../../supabaseClient.js";
import "../../styles/MasterClear.css";

const MasterClear = () => {
  const [tableName, setTableName] = useState("");
  const [password, setPassword] = useState("");

  const handleClear = async () => {
    if (!tableName) {
      alert("Please select what to clear");
      return;
    }

    if (!password) {
      alert("Enter password");
      return;
    }

    // 🔐 Password check (kept as in your uploaded copy)
    if (password !== "admin@123") {
      alert("❌ Incorrect Password");
      return;
    }

    const confirmDelete = window.confirm(
      `⚠ WARNING\n\nThis will PERMANENTLY DELETE all data from ${tableName}.\n\nAre you sure?`
    );
    if (!confirmDelete) return;

    try {
      /* --------------------------------------------------
         MASTER ISSUE + MASTER RECEIVE
      -----------------------------------------------------*/
      if (tableName === "MASTER_DATA") {
        const { error: error1 } = await supabase
          .from("MASTER_RECEIVE")
          .delete()
          .neq("id", "00000000-0000-0000-0000-000000000000");

        const { error: error2 } = await supabase
          .from("MASTER_ISSUE")
          .delete()
          .neq("id", "00000000-0000-0000-0000-000000000000");

        if (error1 || error2) throw (error1 || error2);

        alert("Master Issue & Master Receive cleared successfully!");
        setPassword("");
        setTableName("");
        return;
      }

      /* --------------------------------------------------
         DIAMOND ISSUE + RECEIVE
      -----------------------------------------------------*/
      if (tableName === "DIAMOND_DATA") {
        const { error: diamondError } = await supabase
          .from("DIAMOND_TRANSACTIONS")
          .delete()
          .neq("id", "00000000-0000-0000-0000-000000000000");

        if (diamondError) throw diamondError;

        alert("Diamond Issue & Receive cleared successfully!");
        setPassword("");
        setTableName("");
        return;
      }

      /* --------------------------------------------------
         WAX ISSUE + WAX RECEIVE + CASTING (SAFE ORDER)
         (Deletes casting_done first to avoid FK errors)
      -----------------------------------------------------*/
      if (tableName === "WAX_DATA") {
        // 1) delete casting_done (fk -> wax_item)
        const { error: castErr } = await supabase
          .from("casting_done")
          .delete()
          .neq("id", "00000000-0000-0000-0000-000000000000");
        if (castErr) throw castErr;

        // 2) delete WAX_RECEIVE_ITEMS
        const { error: recErr } = await supabase
          .from("WAX_RECEIVE_ITEMS")
          .delete()
          .neq("id", "00000000-0000-0000-0000-000000000000");
        if (recErr) throw recErr;

        // 3) delete WAX_ITEMS
        const { error: itemsErr } = await supabase
          .from("WAX_ITEMS")
          .delete()
          .neq("id", "00000000-0000-0000-0000-000000000000");
        if (itemsErr) throw itemsErr;

        // 4) delete WAX_LOTS
        const { error: lotsErr } = await supabase
          .from("WAX_LOTS")
          .delete()
          .neq("id", "00000000-0000-0000-0000-000000000000");
        if (lotsErr) throw lotsErr;

        alert("Wax Issue, Wax Receive & Casting Done cleared successfully!");
        setPassword("");
        setTableName("");
        return;
      }

      /* --------------------------------------------------
         CLEAR CASTING DONE ONLY
      -----------------------------------------------------*/
      if (tableName === "CASTING_DONE") {
        const { error } = await supabase
          .from("casting_done")
          .delete()
          .neq("id", "00000000-0000-0000-0000-000000000000");

        if (error) throw error;

        alert("Casting Done Records Cleared Successfully!");
        setPassword("");
        setTableName("");
        return;
      }

      /* --------------------------------------------------
         DEFAULT: Clear a single table by its name
      -----------------------------------------------------*/
      const { error } = await supabase
        .from(tableName)
        .delete()
        .neq("id", "00000000-0000-0000-0000-000000000000");

      if (error) throw error;

      alert(`${tableName} cleared successfully!`);
      setPassword("");
      setTableName("");
    } catch (err) {
      console.error("Clear error:", err);
      // Show server error message if available
      alert(err?.message || "An error occurred while clearing data.");
    }
  };

  return (
    <div className="master-page">
      <div className="master-card">
        <h2 className="master-title">🧹 Clear Master Data</h2>

        <label>Select Data to Clear</label>
        <select
          value={tableName}
          onChange={(e) => setTableName(e.target.value)}
        >
          <option value="">Select Option</option>

          {/* Basic master tables */}
          <option value="WORKERS">Workers</option>
          <option value="ITEMS">Items</option>
          <option value="DIAMONDS">Diamonds</option>

          {/* Combined clears */}
          <option value="MASTER_DATA">Master Issue + Master Receive</option>
          <option value="DIAMOND_DATA">Diamond Issue + Diamond Receive</option>

          {/* Wax related clears */}
          <option value="WAX_DATA">Wax Issue + Wax Receive + Casting</option>
          <option value="CASTING_DONE">Casting Done Records</option>
        </select>

        <label>Enter Password</label>
        <input
          type="password"
          placeholder="Enter admin password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button className="gold-btn" onClick={handleClear}>
          🗑️ CLEAR DATA
        </button>
      </div>
    </div>
  );
};

export default MasterClear;
